module.exports = __webpack_public_path__ + "static/media/2020-07-28 internbit.f750c9e0.md";